/*Import components to ingust in profile */
import Profile from "../../components/Profile/Profile/Profile";

/* Profile Controller to impliment the user profile logic */

export default {
  components: {
    Profile
  }
};
